<div id="paletteColumnId" class="palette-column">
    <div id="palette" class="card">
        <div class="card-header card-title" i18n="@@paletteTitle">
            Palette
        </div>
        <div class="card-body" id="palette-card">
            <div id="accordion" role="tablist">
                <div class="card active">
                    <div class="card-header active" id="label-title">
                        <h6 class="mb-0">
                            <a data-toggle="collapse" class="card-heading" role="button" aria-expanded="false"
                                aria-controls="label-items" href="#label-items" i18n="@@paletteItemLabels">
                                Labels</a>
                        </h6>
                    </div>
                    <div class="card-body collapse show" id="label-items" role="tabpanel" aria-labelledby="label-title"
                        data-parent="#accordion">
                        <div class="list-group">
                            <div *ngFor="let asset of assets">
                                <div *ngIf="asset.category == 'Label'">
                                    <a id="{{asset.id}}" draggable="true" (dragstart)="startDrag($event)"
                                        (dragend)="endDrag($event)" class="list-group-item list-group-item-action">
                                        <img id='{{asset.id}}' class="palette-item-icon" src='{{asset.icon}}'
                                            title='{{asset.name}}' alt='{{asset.name}}'>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="input-title">
                        <h6 class="mb-0">
                            <a data-toggle="collapse" class="card-heading" role="button" aria-expanded="false"
                                aria-controls="input-items" href="#input-items" i18n="@@paletteItemInputs">Inputs</a>
                        </h6>
                    </div>
                    <div class="card-body collapse" id="input-items" role="tabpanel" aria-labelledby="input-title"
                        data-parent="#accordion">
                        <div *ngFor="let asset of assets">
                            <div *ngIf="asset.category == 'Input'">
                                <a draggable="true" id='{{asset.id}}' (dragstart)="startDrag($event)"
                                    (dragend)="endDrag($event)" class="list-group-item list-group-item-action">
                                    <img id='{{asset.id}}' class="palette-item-icon" src='{{asset.icon}}'
                                        title='{{asset.name}}' alt='{{asset.name}}'>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="choice-title">
                        <h6 class="mb-0">
                            <a data-toggle="collapse" class="card-heading" role="button" aria-expanded="false"
                                aria-controls="choice-items" href="#choice-items"
                                i18n="@@paletteItemChoices">Choices</a>
                        </h6>
                    </div>
                    <div class="card-body collapse" id="choice-items" role="tabpanel" aria-labelledby="choice-title"
                        data-parent="#accordion">
                        <div *ngFor="let asset of assets">
                            <div *ngIf="asset.category == 'Choice'">
                                <a draggable="true" id='{{asset.id}}' (dragstart)="startDrag($event)"
                                    (dragend)="endDrag($event)" class="list-group-item list-group-item-action">
                                    <img id='{{asset.id}}' class="palette-item-icon" src='{{asset.icon}}'
                                        title='{{asset.name}}' alt='{{asset.name}}'>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="group-title">
                        <h6 class="mb-0">
                            <a data-toggle="collapse" class="card-heading" role="button" aria-expanded="false"
                                aria-controls="group-items" href="#group-items" i18n="@@paletteItemGroups">Groups</a>
                        </h6>
                    </div>
                    <div class="card-body collapse" id="group-items" role="tabpanel" aria-labelledby="group-title"
                        data-parent="#accordion">
                        <div *ngFor="let asset of assets">
                            <div *ngIf="asset.category == 'Group'">
                                <a draggable="true" id='{{asset.id}}' (dragstart)="startDrag($event)"
                                    (dragend)="endDrag($event)" class="list-group-item list-group-item-action">
                                    <img id='{{asset.id}}' class="palette-item-icon" src='{{asset.icon}}'
                                        title='{{asset.name}}' alt='{{asset.name}}'>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="false">
                    <div class="card-header" id="tool-title">
                        <h6 class="mb-0">
                            <a data-toggle="collapse" class="card-heading" role="button" aria-expanded="false"
                                aria-controls="tool-items" href="#tool-items" i18n="@@paletteItemTools">Tools</a>
                        </h6>
                    </div>
                    <div class="card-body collapse" id="tool-items" role="tabpanel" aria-labelledby="tool-title"
                        data-parent="#accordion">
                        <div *ngFor="let asset of assets">
                            <div *ngIf="asset.category == 'Tool'">
                                <a draggable="true" id='{{asset.id}}' (dragstart)="startDrag($event)"
                                    (dragend)="endDrag($event)" class="list-group-item list-group-item-action">
                                    <img style="width:25%" id='{{asset.id}}' src='{{asset.icon}} '
                                        title='{{asset.name}}' alt='{{asset.name}}'>
                                    <span style="margin-left: 10px;" i18n="@@importPhotoIconTitle">Import Photo
                                        (Beta)</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="myappeaz.expert">
                    <div class="card-header" id="advanced-title">
                        <h6 class="mb-0">
                            <a data-toggle="collapse" class="card-heading" role="button" aria-expanded="false"
                                aria-controls="advanced-items" href="#advanced-items"
                                i18n="@@paletteItemAdvanced">Advanced</a>
                        </h6>
                    </div>
                    <div class="card-body collapse" id="advanced-items" role="tabpanel" aria-labelledby="advanced-title"
                        data-parent="#accordion">
                        <div *ngFor="let asset of assets">
                            <div *ngIf="asset.category == 'Avancé'">
                                <a draggable="true" id='{{asset.id}}' (dragstart)="startDrag($event)"
                                    (dragend)="endDrag($event)" class="list-group-item list-group-item-action">
                                    <div>{{asset.name}}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
